module.exports = __webpack_public_path__ + "static/BlockchainWhychoosingus-53ea0f39c7e8ba274636275719ef5fdb.png";